const runIterableEmailIdKey = require("./runIterableEmailIdKey");

/**
 * @return {undefined | string}
 */
module.exports = function runGetIterableEmailIdFromTheSessionStorage() {
  return window.sessionStorage.getItem(runIterableEmailIdKey()) || undefined;
};
